import React, { useState } from 'react';
import { Form, Input, Button, Select, InputNumber } from 'antd';
import { useParams } from 'react-router';
import { SensorType } from '../../../general/enums';
import { functions } from '../../../firebase';
import { toast } from 'sonner';
import { useAppSelector } from 'hooks';
import { ContainerType } from 'Views/LevelSensorOverview/containerTypes';

const { Option } = Select;

const containerTypeOptions = [
  { value: ContainerType.DRUM_220, label: 'Tromle (220L)' },
  { value: ContainerType.IBC_1000, label: 'IBC (1000L)' },
  { value: ContainerType.WELL_10, label: 'Brønd (10m³)' },
];

const initialValues = {
  type: SensorType.LEVEL_SENSOR_INTERNAL,
  cmLimit: 30,
};

const AddFormLevelSensor = ({
  onClose,
  prefill,
}: {
  onClose: () => void;
  prefill?: { deviceId: string; title: string };
}) => {
  const { orgId } = useParams<{ orgId: string }>();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const members = useAppSelector((state) => state.orgs.currentOrg?.members);

  const memberOptions = Object.entries(members || {})?.map(([_, value]) => ({
    value: value.email,
    label: value.name,
  }));

  const onFinish = async (values: any) => {
    setIsLoading(true);
    const payload = {
      orgId,
      title: values.title,
      deviceId: values.deviceId,
      cmLimit: values.cmLimit,
      internalResponsibles: values.internalResponsibles || [],
      containerType: values.containerType || null,
    };
    const functionRef = functions.httpsCallable('settings');
    const response: any = await functionRef({
      requestType: 'SETUP_LEVEL_SENSOR_INTERNAL',
      ...payload,
    });

    const errorCode = response?.data?.httpErrorCode?.status;
    if (errorCode) {
      return toast.error('Der skete en fejl');
    }
    toast.success('Sensoren blev tilføjet korrekt');
    setIsLoading(false);
    return onClose();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{ ...initialValues, ...prefill }}
    >
      <Form.Item name="title" label="Sensor navn" rules={[{ required: true }]}>
        <Input placeholder="Sensor navn" />
      </Form.Item>
      <Form.Item name="deviceId" label="Sensor id" rules={[{ required: true }]}>
        <Input placeholder="Sensor id (fx 87001)" />
      </Form.Item>
      <Form.Item name="cmLimit" label="Nedre grænse (cm)" rules={[{ required: true }]}>
        <InputNumber placeholder="Nedre grænse (cm)" />
      </Form.Item>
      <Form.Item name="containerType" label="Beholder type (valgfri)">
        <Select placeholder="Vælg beholder type" allowClear>
          {containerTypeOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="internalResponsibles"
        label="Intern aks2tal ansvarlig"
        rules={[{ required: true }]}
      >
        {/* dropdown of org members */}
        <Select mode="multiple" placeholder="Vælg intern aks2tal ansvarlig">
          {memberOptions?.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={isLoading}>
          Tilføj
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddFormLevelSensor;
